import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "geo-limit-currency-configuration" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "geo-limit-currency-configuration__limits" }
const _hoisted_4 = { class: "geo-limit-currency-configuration__wrapper" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "geo-limit-currency-configuration__label" }, "Deposit limit", -1 /* HOISTED */)
const _hoisted_6 = { class: "geo-limit-currency-configuration__input-group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "geo-limit-currency-configuration__label" }, "Currency", -1 /* HOISTED */)
const _hoisted_8 = { class: "geo-limit-currency-configuration__currency-group" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "geo-limit-currency-configuration__limits" }
const _hoisted_11 = { class: "geo-limit-currency-configuration__wrapper" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "geo-limit-currency-configuration__label" }, "Cash out limit", -1 /* HOISTED */)
const _hoisted_13 = { class: "geo-limit-currency-configuration__input-group" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "geo-limit-currency-configuration__label" }, "Currency", -1 /* HOISTED */)
const _hoisted_15 = { class: "geo-limit-currency-configuration__currency-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isDepositColumnsDataVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.geoPaymentMethodsSettingsFormData.depositLimitList, (depositLimit, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _hoisted_5,
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_el_input_number, {
                        modelValue: depositLimit.min,
                        "onUpdate:modelValue": ($event: any) => ((depositLimit.min) = $event),
                        placeholder: "Min",
                        controls: false,
                        class: "geo-limit-currency-configuration__field"
                      }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_el_input_number, {
                        modelValue: depositLimit.max,
                        "onUpdate:modelValue": ($event: any) => ((depositLimit.max) = $event),
                        placeholder: "Max",
                        controls: false,
                        class: "geo-limit-currency-configuration__field"
                      }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_el_select, {
                        modelValue: depositLimit.currency,
                        "onUpdate:modelValue": ($event: any) => ((depositLimit.currency) = $event),
                        class: "geo-limit-currency-configuration__field",
                        placeholder: "Select currency",
                        teleported: false
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableDepositCurrencyList, (currency) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: currency.code,
                              label: currency.code,
                              value: currency.code
                            }, null, 8 /* PROPS */, ["label", "value"]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_el_button, {
                        type: "danger",
                        icon: _ctx.icons.Delete,
                        circle: "",
                        plain: "",
                        onClick: ($event: any) => (_ctx.deleteCurrencyDepositLimitItem(index))
                      }, null, 8 /* PROPS */, ["icon", "onClick"])
                    ])
                  ])
                ])
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          _createVNode(_component_el_button, {
            type: "primary",
            icon: _ctx.icons.Plus,
            plain: "",
            onClick: _ctx.addCurrencyDepositLimitItem
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Add currency deposit ")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["icon", "onClick"])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.isWithdrawColumnsDataVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.geoPaymentMethodsSettingsFormData.withdrawLimitList, (withdrawLimit, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, [
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_el_input_number, {
                        modelValue: withdrawLimit.min,
                        "onUpdate:modelValue": ($event: any) => ((withdrawLimit.min) = $event),
                        placeholder: "Min",
                        controls: false,
                        class: "geo-limit-currency-configuration__field"
                      }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_el_input_number, {
                        modelValue: withdrawLimit.max,
                        "onUpdate:modelValue": ($event: any) => ((withdrawLimit.max) = $event),
                        placeholder: "Max",
                        controls: false,
                        class: "geo-limit-currency-configuration__field"
                      }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_el_select, {
                        modelValue: withdrawLimit.currency,
                        "onUpdate:modelValue": ($event: any) => ((withdrawLimit.currency) = $event),
                        class: "geo-limit-currency-configuration__field",
                        placeholder: "Select currency",
                        teleported: false
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableCashoutCurrencyList, (currency) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: currency.code,
                              label: currency.code,
                              value: currency.code
                            }, null, 8 /* PROPS */, ["label", "value"]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_el_button, {
                        type: "danger",
                        icon: _ctx.icons.Delete,
                        circle: "",
                        plain: "",
                        onClick: ($event: any) => (_ctx.deleteCurrencyWithdrawLimitItem(index))
                      }, null, 8 /* PROPS */, ["icon", "onClick"])
                    ])
                  ])
                ])
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          _createVNode(_component_el_button, {
            type: "primary",
            icon: _ctx.icons.Plus,
            plain: "",
            onClick: _ctx.addCurrencyWithdrawLimitItem
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Add currency cash out ")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["icon", "onClick"])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}